import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stageLabelsById: {},
  characterLabelsById: {},
};

export const runDisplaySlice = createSlice({
  name: 'runDisplay',
  initialState,
  reducers: {
    setStageLabel: (state, action) => {
      const { slotId, label } = action.payload;
      state.stageLabelsById[String(slotId)] = label;
    },
    clearStageLabel: (state, action) => {
      const { slotId } = action.payload;
      delete state.stageLabelsById[String(slotId)];
    },
    setCharacterLabel: (state, action) => {
      const { slotId, label } = action.payload;
      state.characterLabelsById[String(slotId)] = label;
    },
    clearCharacterLabel: (state, action) => {
      const { slotId } = action.payload;
      delete state.characterLabelsById[String(slotId)];
    },
  },
});

export const {
  setStageLabel,
  clearStageLabel,
  setCharacterLabel,
  clearCharacterLabel,
} = runDisplaySlice.actions;

export default runDisplaySlice.reducer;
